<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="颜色、尺码名称自定义"
      :visible.sync="visible"
      width="600px"
      @close="handleClose"
      class="amazon_category_dialog"
    >
      <div>
        <el-table
          :key="index"
          :data="colorList"
          :header-cell-style="{ 'text-align': 'center' }"
          border
          style="width: 100%; margin-top: 20px"
          align="center"
        >
          <el-table-column
            align="center"
            prop="sysName"
            label="系统颜色名称"
            width="180"
          >
            <template slot-scope="scope">
              <div style="overflow:hidden;">
                <div style="text-align:center">
                  {{ scope.row.sysName }}

                  <span v-if="dictMap['language'][scope.row.sysName]">
                    ({{ dictMap["language"][scope.row.sysName] }})</span
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="customizeName" label="自定义颜色名称">
            <template slot="header" slot-scope="scope">
              自定义颜色名称<br />
              <span style="color:#aaaaaa;"
                >如原是中文则可以改成：blue、red等<br />如不确定则填输入“standard”</span
              >
            </template>
            <template slot-scope="scope">
              <div style="overflow:hidden;">
                <el-input
                  v-model="scope.row.customizeName"
                  placeholder="请输入内容"
                  size="mini"
                ></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :key="index"
          :data="sizeList"
          :header-cell-style="{ 'text-align': 'center' }"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            align="center"
            prop="sysName"
            label="系统尺码名称"
            width="180"
          >
            <template slot-scope="scope">
              <div style="overflow:hidden;">
                <div style="text-align:center">{{ scope.row.sysName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="customizeName" label="自定义尺码名称">
            <template slot="header" slot-scope="scope">
              自定义颜色名称<br />
              <span style="color:#aaaaaa;"
                >如原是中文则可以改成：s、xl、l等<br />如不确定则填输入“One
                Size”</span
              >
            </template>
            <template slot-scope="scope">
              <div style="overflow:hidden;">
                <el-input
                  v-model="scope.row.customizeName"
                  placeholder="请输入内容"
                  size="mini"
                ></el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="float:left;"
          type="primary"
          @click="handleClear"
          size="small"
          >清 空</el-button
        >
        <el-button type="primary" @click="handleSubmit" size="small"
          >确 定</el-button
        >
        <el-button @click="handleClose" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {} from "@/api/template/template"
import { mapGetters } from "vuex"

export default {
  name: "PriceConfigDialog",
  data() {
    return {
      showPriceDialog: false,
    }
  },
  watch: {
    visible: {
      async handler() {
        if (this.visible) {
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapGetters(["user", "dictMap", "dictData"]),
  },
  model: {
    prop: "visible",
    event: "change",
  },
  mounted() {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    colorList: {
      type: Array,
      default: () => {
        return []
      },
    },
    sizeList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },

  methods: {
    handleSubmit() {
      debugger
      this.$emit("change", false)
      this.$emit("update", {
        colorList: this.colorList,
        sizeList: this.sizeList,
      })
    },
    handleUpdatePrice() {
      this.showPriceDialog = false
    },
    handleShowPriceDialog(priceType) {
      this.priceModify = ""
      this.showPriceDialog = true
      this.priceType = priceType
    },
    handleClosePriceDialog() {
      this.showPriceDialog = false
    },
    handleClose() {
      this.$emit("change", false)
    },
    handleClear() {
      for (let record of this.colorList) {
        record.customizeName = ""
      }
      for (let record of this.sizeList) {
        record.customizeName = ""
      }
    },
  },
}
</script>

<style scoped>
.avator img {
  width: 100px;
}
.avator {
  float: left;
}
.info {
  float: left;
  margin-left: 4px;
}

.amazon_category_dialog ::v-deep .el-dialog__body {
  height: 60vh;
  overflow-y: scroll;
}
</style>
